import React from 'react';
import PropTypes from 'prop-types';
import css from './SectionTalentHero.module.css';
import { capitalizeFirstLetter, isArrayLength } from '../../../../util/genericHelpers';
import { FormattedMessage } from 'react-intl';

const SectionInterests = ({ pub_interest = [], interest = [] }) => {
  const hasPublicInterests = isArrayLength(pub_interest);
  const hasInterests = isArrayLength(interest);

  // If no interests exist, don't render the section
  if (!hasPublicInterests && !hasInterests) return null;

  // Helper to render interest items with a transformation function
  const renderInterestItems = (items, transformFn) =>
    items.map((item, index) => (
      <span key={index}>
        <strong>{transformFn(item)}</strong>
      </span>
    ));

  return (
    <div className={css.keywordSec}>
      <h2>
        <FormattedMessage id="SectionHero.interests" defaultMessage="Interests" />
      </h2>
      <div className={css.keywords}>
        {hasPublicInterests &&
          renderInterestItems(pub_interest, item => capitalizeFirstLetter(item))}
        {hasInterests && renderInterestItems(interest, item => item?.value)}
      </div>
    </div>
  );
};

SectionInterests.propTypes = {
  pub_interest: PropTypes.array,
  interest: PropTypes.array,
};

export default SectionInterests;
